import type { ErrorFallbackModelProps } from '@/components/shared/error-fallback/error-fallback.model'
import { useErrorFallbackModel } from '@/components/shared/error-fallback/error-fallback.model'
import { ErrorFallbackView } from '@/components/shared/error-fallback/error-fallback.view'

export function ErrorFallbackViewModel(props: ErrorFallbackModelProps) {
  const model = useErrorFallbackModel(props)
  return <ErrorFallbackView {...model} />
}
